import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Page from '@feathr/extender/App/Page';
import { getGreeting } from '@feathr/extender/App/ReportsAudienceEngagementPage';
import { useUser } from '@feathr/extender/state';

import AdPerformance from './AdPerformance';
import AudienceEngagement from './AudienceEngagement';
import EmailPerformance from './EmailPerformance';

function DashboardPage(): JSX.Element {
  const { t } = useTranslation();
  const { name } = useUser();

  const currentHour = new Date().getHours();
  const greeting = getGreeting(currentHour, name, t);

  return (
    <Page collapseHeader={false} pageTitle={t('Dashboard')} title={greeting}>
      <AudienceEngagement />
      <EmailPerformance />
      <AdPerformance />
    </Page>
  );
}

export default observer(DashboardPage);
